import script from "./subMenuModal.vue?vue&type=script&setup=true&lang=js"
export * from "./subMenuModal.vue?vue&type=script&setup=true&lang=js"

import "./subMenuModal.vue?vue&type=style&index=0&id=e9002662&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9002662"]])

export default __exports__